<template>
    <div class="px-3 py-2">
        <b-modal
            id="fix_salary"
            ref="modalAdvanced"
            :title="$parent.lang.fix_salary"
            size="lg"
            :footer-bg-variant="`warning`"
            :header-bg-variant="`dark`"
            :header-text-variant="`light`"
            lazy
        >
            <template #modal-header >
                <div class="w-100 flexit" style="direction:rtl;text-align:center">
                    <div style="margin-bottom:5px!important;font-size:1.3rem;border:2px solid #fff !important;width:150px;display:flex;justify-content: center;justify-items: center;align-items: center;">
                        {{ $parent.lang.fix_salary }}
                    </div>
                </div>
            </template>

        
                <div class="px-3 py-2" :style="`direction:`+$parent.lang.dir">
                    <v-form ref="apform">
                        <v-row>
                            <v-col cols="12" md="4" sm="12">
                                <label>اجمالي الراتب</label>
                                <b-form-input class="inborder"
                                    label="اجمالي الراتب"
                                    v-model="stotal"
                                    :rules="fieldRules"
                                    type="number"
                                    readonly
                                    ></b-form-input>
                            </v-col>
                            <v-col cols="12" md="4" sm="12">
                                <label>الخصومات</label>
                                <b-form-input class="inborder"
                                    label="الخصومات"
                                    v-model="discounts"
                                    :rules="fieldRules"
                                    type="number"
                                    ></b-form-input>
                            </v-col>
                            <v-col cols="12" md="4" sm="12">
                                <label>السلف</label>
                                <b-form-input class="inborder"
                                    label="السلف"
                                    v-model="padvanced"
                                    :rules="fieldRules"
                                    type="number"
                                    ></b-form-input>
                            </v-col>
                            <v-col cols="12" md="4" sm="12">
                                <label>المكافآت</label>
                                <b-form-input class="inborder"
                                    label="المكافآت"
                                    v-model="bonuce"
                                    :rules="fieldRules"
                                    type="number"
                                    ></b-form-input>
                            </v-col>
                            <v-col cols="12" md="4" sm="12" v-if="$store.state.licenseType.cars">
                                <label>نسبة كروت الصيانة</label>
                                <b-form-input class="inborder"
                                    label="نسبة كروت الصيانة"
                                    v-model="ptotal"
                                    :rules="fieldRules"
                                    type="number"
                                    ></b-form-input>
                            </v-col>
                            <v-col cols="12" md="4" sm="12">
                                <label>نسبة الفواتير</label>
                                <b-form-input class="inborder"
                                    label="نسبة الفواتير"
                                    v-model="ipercentage"
                                    :rules="fieldRules"
                                    type="number"
                                    ></b-form-input>
                            </v-col>
                            <!-- <v-col cols="12" md="6" sm="12">
                                <label>{{$parent.lang.payment_type}}</label>
                                <b-input-group>
                                <b-form-select
                                    class="selborder"
                                    v-model="payment_type"
                                    :options="paytypes"
                                    :label="$parent.lang.payment_type"
                                    ></b-form-select>
                                <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                    <i class="fas fa-arrow-down"></i>
                                    </b-input-group-append>
                                </b-input-group>
                            </v-col> -->
                            <v-col cols="12" md="6" sm="12">
                                <label>ملاحظات على الراتب</label>
                                <b-form-textarea class="inborder"
                                    placeholder="ادخل ملاحظات عن تعديل القيم"
                                    v-model="notes"
                                    style="height:100px;width:100%;"
                                    ></b-form-textarea>
                            </v-col>
                        </v-row>
                        <v-row class="m-2">
                            <v-col cols="4" style="background:darkblue;color:#FFF;text-align:center;">صافي الراتب</v-col>
                            <v-col cols="8" style="background:darkgreen;color:#FFF;text-align:center;">{{paidsalary}}</v-col>
                        </v-row>
                    </v-form>
                </div>
                <template #modal-footer="{ close }" >
                    <div class="w-100" style="direction:rtl;text-align:center;">
                        <b-button type="button" @click='addit()' style="font-size:1.1rem;border:2px solid #fff !important;background:green !important;width:120px;color:#fff;" class="mytab2 btn btn-sm btn-success ms-2">{{ $parent.lang.save }}</b-button>
                        <b-button type="button" @click='close()' style="font-size:1.1rem;border:2px solid #fff !important;background:red !important;width:120px;color:#fff;" class="mytab2 btn btn-sm btn-success ms-2">{{ $parent.lang.close }}</b-button>
                    </div>
                </template>
            </b-modal>
    </div>
</template>

<script>
import axios from 'axios'
import {SnotifyPosition} from 'vue-snotify';
export default{
    data() {
        return {
            empid: 0,
            stotal: 0,
            discounts: 0,
            padvanced: 0,
            bonuce: 0,
            ptotal: 0,
            ipercentage: 0,
            paytypes: [],
            payment_type: 1,
            fieldRules: [
                v => !!v || this.$parent.lang.required_field
            ],
            fixit: false,
            notes: '',
        }
    },
    created(){
        this.getPyamentType();
    },
    computed: {
        paidsalary: function(){
            let t = 0;
            t = parseFloat(this.stotal) + parseFloat(t);
            t = parseFloat(t) - parseFloat(this.discounts);
            t = parseFloat(t) - parseFloat(this.padvanced);
            t = parseFloat(t) + parseFloat(this.bonuce);
            t = parseFloat(t) + parseFloat(this.ptotal);
            t = parseFloat(t) + parseFloat(this.ipercentage);
            return t;
        }
    },
    methods: {
        getPyamentType(){
            const post = new FormData();
            post.append('type','getPayTypes');
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]',"all");
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                this.payTypeOp = [];
                for(let i=0;i<res.results.data.length;i++){
                    this.paytypes.push({
                        text: this.$parent.lang.langname == 'ar' ? res.results.data[i].type_name : res.results.data[i].type_name_en,
                        value: res.results.data[i].id
                    })
                }
            })
        },
        changeValue(i){
            if(i == 1){ this.stotal = this.stotal == '' ? 0 : this.stotal;}
            if(i == 2){ this.stotal = this.stotal == '' ? 0 : this.stotal;}
        },
        doitall(){
            this.empid = this.$parent.employees.id ;
            this.stotal = this.$parent.employees.stotal;
            this.discounts = this.$parent.discounts
            this.padvanced = this.$parent.padvanced
            this.bonuce = this.$parent.bonuce
            this.ptotal = this.$parent.ptotal
            this.ipercentage = this.$parent.ipercentage
        },
        addit() {
            
            const post = new FormData();
            post.append("type","fixSalary");
            post.append("auth",this.$cookies.get(this.$COOKIEPhase))
            post.append("data[stotal]",this.stotal);
            post.append("data[discounts]",this.discounts);
            post.append("data[padvanced]",this.padvanced);
            post.append("data[bonuce]",this.bonuce);
            post.append("data[ptotal]",this.ptotal);
            post.append("data[ipercentage]",this.ipercentage);
            post.append("data[month]",this.$parent.month);
            post.append("data[year]",this.$parent.year);
            post.append("data[paidsalary]",this.paidsalary);
            post.append("data[notes]",this.notes);
            post.append("data[empid]",this.empid);
            post.append("data[paytype]",this.payment_type);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                // console.log(response.data);
                let message = 'تم اصدار الراتب بنجاح';
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close, 
                            action: (toast) => {
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                    ]
                });
                this.amount = '',
                this.installment_number = 1;   
                this.$parent.getEmployees();             
                document.getElementById('fxhideExp').click();

            })
        }
    },
}
</script>